export default "__VITE_ASSET__BWYfT1YV__"